import _ from 'lodash';

export function computedFiltersDescription(filters) {

  return _.keys(filters)
    .map(o => ({ name: `${o}`, description: filters[o]?.description }))
    .filter(o => o.description !== undefined);
}